import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  ACTION_GET_COSTESTIMATE_STATE,
  ACTION_GET_COSTESTIMATE_ORIGIN_CITY,
  ACTION_GET_COSTESTIMATE_DESTINATION_CITY,
  ACTION_GET_SHIPPING_TOTAL,
  ACTION_GET_COSTESTIMATE_DEFAULT_CONFIG,
  ACTION_GET_COSTESTIMATE_APPROVERS,
} from "../../../Actions/actions";
import countryStateCity from "../../../services/CountryStateCity/CountryStateCity";
import costEstimatesService from "../../../services/CostEstimates/CostEstimates";

interface intialState {
  data: any;
}

export const initialState: intialState = {
  data: {
    live: {},
    global: {
      step1: {
        symbol: "$",
        clientId: "180",
        divisionId: "Init Division",
        name: "Germany Homeowner Est",
        policy: "International Move - Homeowner",
        currency: "USD",
        assignmentType: "longTerm",
        assignmentDurationYear: 4,
        assignmentDurationMonth: 6,
        originAddressLine1: "1517 Lakeview Drive, Keller",
        originAddressLine2: "",
        originZipcode: "76248",
        originCountry: "United States",
        originState: "Texas",
        originCity: "Keller",
        destinationCountry: "Germany",
        destinationState: "North Rhine-Westphalia",
        destinationCity: "Mönchengladbach",
        adults: 4,
        schoolAgeDependents: 2,
        baseAnnualSalary: "200,000.00",
        salaryLocation: "United States",
        residenceType: "HOMEOWNER",
        estimatedHomeValue: "700,000.00",
        vehicleOwnership: "RENT",
        housingPreference: "premium",
        clientName: "ABC Company",
      },
      step2: {
        relocationAllowanceTotal: "4,000.00",
        homeSearchTotal: "4,696.00",
        // homeDispositionTotal: "56,000.00",
        vehicleDispositionTotal: "1,500.00",
        longTermStorageTotal: "0.00",
        householdGoodsShipmentTotal: "25,500.00",
        householdGoodsShipmentRepatriation: true,
        householdGoodsShipmentRepatriationTotal: "25,500.00",
        finalMoveTotal: "2,682.00",
        settlingInServicesTotal: "1,700.00",
        schoolSearchTotal: "1,550.00",
        culturalTrainingTotal: "1,000.00",
        languageTrainingTotal: "3,250.00",
        temporaryHousingTotal: "4,139.00",
        transportationAllowanceTotal: "32,400.00",
        homeLeaveTripsTotal: "8,528.00",
        deRegistrationAssistanceTotal: "550.00",
        homeFindingTripTotal: "2,826.00",
        temporaryHousingRepatriationTotal: "3,750.00",
        finalMoveRepatriationTotal: "2,632.00",
        relocationAllowance: true,
        salaryPercentage: "2.00",
        homeSearch: true,
        numberOfTravellers: 4,
        numberOfDays: 5,
        perDiemForMeals: "75.00",
        carRentalLocalTransportation: "375.00",
        numberOfTravellers1: 4,
        numberOfDaysTravellers: 4,
        destinationTravelDays: 2,
        travelTimePeriod: "full",
        airfareTraveller: "1,426.00",
        flightClass: "Economy",
        homeDisposition: false,
        homeValue: "8.00",
        financialCap: "700,000.00",
        vehicleDisposition: true,
        vehicleValue: "11.00",
        financialCapVehicle: "240.00",
        longTermStorage: false,
        householdGoodsShipment: true,
        weightCap: "1,000.00",
        surfaceContainerSize: "40",
        finalMove: true,
        numberOfTravellersFinalMove: 4,
        numberOfDaysFinalMove: 2,
        perDiemForMealsFinalMove: "75.00",
        airfareTravellerFinalMove: "2,132.00",
        flightClassFinalMove: "Economy",
        settlingInServices: true,
        daysSettlingInServices: 1.5,
        timePeriodSettlingInServices: "half",
        financialCapSettlingInServices: "200.00",
        schoolSearch: true,
        daysSchoolSearch: 1.5,
        timePeriodSchoolSearch: "half",
        financialCapSchoolSearch: "200.00",
        culturalTraining: true,
        daysCulturalTraining: 2,
        timePeriodCulturalTraining: "half",
        financialCapCulturalTraining: "350.00",
        languageTraining: true,
        hoursLanguageTraining: 50,
        financialCapLanguageTraining: "350.00",
        temporaryHousing: true,
        daysTemporaryHousing: 42,
        timePeriodTemporaryHousing: "first",
        transportationAllowance: true,
        monthlyAmount: "600.00",
        homeLeaveTrips: true,
        tripCountHomeLeaveTrips: 1,
        numberOfTravellersHomeLeaveTrips: 4,
        airfareTravellerHomeLeaveTrips: "2,500.00",
        flightClassHomeLeaveTrips: "Economy",
        deRegistrationAssistance: true,
        daysDeRegistrationAssistance: 15,
        homeFindingTrip: true,
        numberOfTravellersHomeFindingTrip: 2,
        numberOfDaysHomeFindingTrip: 5,
        perDiemForMealsHomeFindingTrip: "75.00",
        carRentalLocalTransportationHomeFindingTrip: "400.00",
        numberOfTravellersHomeFindingTrip2: 2,
        numberOfDaysHomeFindingTrip2: 7,
        flightClassHomeFindingTrip2: "Economy",
        temporaryHousingRepatriation: true,
        daysTemporaryHousingRepatriation: 30,
        timePeriodTemporaryHousingRepatriation: "second",
        finalMoveRepatriation: true,
        numberOfTravellersFinalMoveRepatriation: 4,
        numberOfDaysFinalMoveRepatriation: 2,
        perDiemForMealsFinalMoveRepatriation: "75.00",
        airfareTravellerFinalMoveRepatriation: "2,132.00",
        flightClassFinalMoveRepatriation: "Economy",
        earlyLeaseTerminationFee: "1,500.00",
        numberOfSchoolAgeChildren: "2",
        annualCostSchoolCost: "45,000.00",
        schoolCostTotal: "202,500.00",
        schoolCost: true,
        cola: true,
        colaFactor: "125.00",
        colaCost: "50,000.00",
        colaTotal: "225,000.00",
        airfareHomeFindingTrip2: "1,426.00",
        total: 1733035,
      },
    },
  },
};

export const getState = createAsyncThunk(
  ACTION_GET_COSTESTIMATE_STATE,
  async ({ countryId }: { countryId: string }) => {
    return countryStateCity.getState(countryId);
  },
);

export const getOriginState = createAsyncThunk(
  "ACTION_GET_COSTESTIMATE_ORIGIN_STATE",
  async ({ countryId }: { countryId: string }) => {
    return countryStateCity.getState(countryId);
  },
);

export const getDestinationState = createAsyncThunk(
  "ACTION_GET_COSTESTIMATE_DESTINATION_STATE",
  async ({ countryId }: { countryId: string }) => {
    return countryStateCity.getState(countryId);
  },
);

export const getOriginCity = createAsyncThunk(
  ACTION_GET_COSTESTIMATE_ORIGIN_CITY,
  async ({ countryId, stateId }: { countryId: string; stateId: string }) => {
    return countryStateCity.getCity(countryId, stateId);
  },
);

export const getDestinationCity = createAsyncThunk(
  ACTION_GET_COSTESTIMATE_DESTINATION_CITY,
  async ({ countryId, stateId }: { countryId: string; stateId: string }) => {
    return countryStateCity.getCity(countryId, stateId);
  },
);

const getStateFullfield = (state: any, action: any) => {
  state.data.state = action.payload?.data;
};

const getOriginStateFullfield = (state: any, action: any) => {
  state.data.originState = action.payload?.data;
};

const getDestinationStateFullfield = (state: any, action: any) => {
  state.data.destinationState = action.payload?.data;
};

const getOriginCityFullfield = (state: any, action: any) => {
  state.data.originCity = action.payload?.data;
};

const getDestinationCityFullfield = (state: any, action: any) => {
  state.data.destinationCity = action.payload?.data;
};

export const getShippingTotal = createAsyncThunk(
  ACTION_GET_SHIPPING_TOTAL,
  async (data: any) => {
    return costEstimatesService.getShippingTotal(data);
  },
);

const getShippingTotalFullfield = (state: any, action: any) => {
  state.data.live.shg.shgTotalAPI = action.payload?.data?.total || 0;
  state.data.live.shgTotalAPI = action.payload?.data?.total || 0;
};

export const getDefaultConfig = createAsyncThunk(
  ACTION_GET_COSTESTIMATE_DEFAULT_CONFIG,
  async (data: any) => {
    return costEstimatesService.getDefaultConfig(data);
  },
);

const getDefaultConfigFullfield = (state: any, action: any) => {
  state.data.default = action.payload?.data;
};

export const getApprovers = createAsyncThunk(
  ACTION_GET_COSTESTIMATE_APPROVERS,
  async (data: any) => {
    return costEstimatesService.getApprovers(data);
  },
);

const getApproversFullfield = (state: any, action: any) => {
  state.data.approvers = action.payload?.data;
};

const costEstimatesSlice = createSlice({
  name: "costEstimates",
  initialState,
  reducers: {
    updateLive(state, action) {
      state.data.live = action.payload;
    },
    updateGlobal(state, action) {
      state.data.global = action.payload;
    },
    resetState: () => initialState,
  },
  extraReducers(builder): void {
    builder.addCase(getState.fulfilled, getStateFullfield);
    builder.addCase(getOriginState.fulfilled, getOriginStateFullfield);
    builder.addCase(
      getDestinationState.fulfilled,
      getDestinationStateFullfield,
    );
    builder.addCase(getOriginCity.fulfilled, getOriginCityFullfield);
    builder.addCase(getDestinationCity.fulfilled, getDestinationCityFullfield);
    builder.addCase(getShippingTotal.fulfilled, getShippingTotalFullfield);
    builder.addCase(getDefaultConfig.fulfilled, getDefaultConfigFullfield);
    builder.addCase(getApprovers.fulfilled, getApproversFullfield);
  },
});

export default costEstimatesSlice.reducer;
export const { updateLive, resetState, updateGlobal } =
  costEstimatesSlice.actions;
